module.exports = __webpack_public_path__ + "42aaeb450ee6ccf69fbab816d7d5ea6b.svg";